import "./index.scss";
import Alpine from 'alpinejs';

import { $, $all, forEach, on, addClass, removeClass } from "@olmokit/dom";

import { globalData } from "@olmokit/core/data";
import { post } from "@olmokit/core/fragments/ajax";
import LazyLoad from "@olmokit/core/lazy";
import { render } from "@olmokit/utils/render";

import { FiltersPagination } from "components/Filters/Pagination";

/**
 * Component: Filters
 */
export function Filters() {
  console.log("Filters mounted.");

  const $product = $("#card-product");
  const $pagination = $("#pagiantion-filters");

  const renderCardProduct = render($product.innerHTML);
  const renderFilterPagination = render($pagination.innerHTML);
  
  Alpine.store('filters', {
    items: {'brand': []},
    params: [],
  
    addParams(value) {
      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search.slice(1));
      params.append(value.prop, value.id);
      window.history.replaceState({}, "", `${location.pathname}?${params}`);
    },
  
    removeParams(value) {
      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search.slice(1));
      params.delete(value.prop, value.id);
      window.history.replaceState({}, "", `${location.pathname}?${params}`);
    }, 
  
    add(value, type) {
      this.items[type].push(value);
  
      this.filter();
    },
  
    remove(value, type) {
      const array = this.items[type].filter(e => e.id != value.id);
      this.items[type] = array;
  
      this.filter();    
    },  
  
    check(id, label, type) {
  
      const property = {
        id: id,
        label: label
      };
  
      if(this.search(property.id, this.items[type])){
        this.remove(property, type);
      } else {
        this.add(property, type);
      }
  
    },
  
    search(nameKey, myArray) {
      return myArray.find(item => item.id === nameKey) || null;
    },
  
    removeButton(value, type) {
      this.remove(value, type);    
      this.removeCheck(value, type);
    },
  
    removeCheck(value, type) {
      const check = $('.'+type+'-'+value.id);
      check.checked = false;
    },
  
    removeAll() {
      for (const [key, value] of Object.entries(this.items)) {
        value.forEach((e) => {
          this.remove(e, key);
          this.removeCheck(e, key);
        });
      }
  
    },
  
    loadingPage() {
      let url = window.location.href;
      let urlUrl = new URL(url);
      let params = new URLSearchParams(urlUrl.search.slice(1));  
    
      const $radio = $all(".Filters:property_value.radiox input.formControl");
    
      for (let p of params) {    
    
        forEach($radio, (el) => {
  
          const prop = el.getAttribute('data-value');
  
          if(idType != p[0]){
            const value = {id: p[1], label: 'none', prop: p[0]};
            this.removeParams(value)
          } else if(prop == p[1]){
            const id = el.getAttribute('data-value');
            const label = el.getAttribute('data-name');
            const property = el.getAttribute('data-property');
            const value = {id: id, label: label, prop: property};
  
            el.checked = true;
            this.add(value);
          }
        });
    
      }
  
      if(this.items.length > 0){
        this.filter();
      }
    },
  
    filter() {
  
      // let queryValues = {};
  
      const queryBrands = this.items.brand.map((e) => {
        return e.id
      });
  
      // for(let i = 0; i < this.items.length; i++){        
      //   if(queryValues[this.items[i].prop] != undefined){
      //     queryValues[this.items[i].prop].push(this.items[i].id);
      //   } else {
      //     queryValues[this.items[i].prop] = [this.items[i].id];
      //   }
      // }
  
      // let queryValuesIds= [];
  
      // for (const [key, value] of Object.entries(queryValues)) {
      //   queryValuesIds.push(JSON.parse("[" + value + "]"));
      // }
      // console.log('queryValuesIds', queryValuesIds);
    
      const loader = $('.loader');
      // const numProd = $('#numProd');
    
      loader.style.display = 'flex';
    
      post('filters', {
        data: {
          id: '',
          idpage: '1',
          macrocategory: globalData.macroidcat,
          category: globalData.idcat,
          brands: queryBrands
        },
      }).then(({ data }) => {
  
        const $products = $("#card-products");
        const $paginationfilter = $("#pagination");
        const $numProd = $("#productFound");
        const $numTotal = $("#productTotal");
  
        $products.innerHTML = renderCardProduct({
          results: data.elements
        });

        const array = [];
        for(let i = 0; i < data.pagenumber; i++){
          array.push(i+1);
        }

        $paginationfilter.innerHTML = renderFilterPagination({
          results: data.elements,
          pagenumber: array,
          pagecurrent: data.pagecurrent,
          fulltotal: data.fulltotal,
        });
        // new LazyLoad();

        if(data.fulltotal > 100){
          FiltersPagination(queryBrands);
        }
  
        $numProd.innerHTML = data.count;
        $numTotal.innerHTML = data.fulltotal;
    
        loader.style.display = 'none';
    
      });      
    }
  });
   
  Alpine.start();

}
